define('TescoMobile_Catalog/js/action/return-cart-ajax-reload',['mage/url', 'mage/storage'], function (urlBuilder, storage) {
  'use strict';

  return function (deferred, quoteId) {
    deferred = deferred || $.Deferred();
    urlBuilder.setBaseUrl(window.BASE_URL);
    const serviceUrl = urlBuilder.build('checkout/cart/ajaxreload');
    return storage.post(serviceUrl).done(function (response) {
      deferred.resolve(response);
    }).fail(function (response) {
      deferred.reject();
    });
  };
});

